import type { Language, Translations } from "./translations";

const supportedLanguages: Language[] = ["fr", "nl", "en"];

export function getSupportedLanguages() {
  return [...supportedLanguages];
}

export async function loadTranslations(language: Language): Promise<Translations> {
  switch (language) {
    case "fr":
      return (await import("./translations/fr")).frTranslations;
    case "nl":
      return (await import("./translations/nl")).nlTranslations;
    case "en":
      return (await import("./translations/en")).enTranslations;
  }
}
